const offlineCourseLocation = () => {
  const regionSelect = document.getElementById('offline_course_region');
  const citySelect   = document.getElementById('offline_course_city');

  if (!regionSelect || !citySelect) return;

  const setCityLoading = (state) => {
    if (state) {
      citySelect.disabled = true;
      citySelect.classList.add('is-loading');
      if (window.jQuery && jQuery.fn.select2) {
        jQuery(citySelect).trigger('change.select2');
      }
    } else {
      citySelect.disabled = false;
      citySelect.classList.remove('is-loading');
      if (window.jQuery && jQuery.fn.select2) {
        jQuery(citySelect).trigger('change.select2');
      }
    }
  };

  const loadCities = (region) => {
    citySelect.innerHTML = '<option value="">Виберіть Місто</option>';
    setCityLoading(true);

    if (!region) {
      setCityLoading(false);
      return;
    }

    jQuery.ajax({
      url: rcData.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: { action: 'get_cities_by_region', region, nonce: rcData.nonce, post_id: rcData.postId }
    })
      .then(data => {
        citySelect.innerHTML = '<option value="">Виберіть Місто</option>';

        if (data.success && data.data) {
          data.data.forEach(city => {
            const option = document.createElement('option');
            option.value = city;
            option.textContent = city;
            citySelect.appendChild(option);
          });
        }

        setCityLoading(false);
      })
      .catch(err => {
        console.error('City loading error:', err);
        setCityLoading(false);
      });
  };

  if (window.jQuery && jQuery.fn.select2) {
    jQuery(regionSelect).on('change.select2', (e) => {
      loadCities(e.target.value);
    });
  }

  const initialRegion = regionSelect.value;
  const initialCity   = citySelect.value;

  if (initialRegion) {
    loadCities(initialRegion, initialCity || null);
  }

  const hiddenRegion = document.querySelector('input[name="c_region"]');
  const hiddenCity   = document.querySelector('input[name="c_city"]');

  if (hiddenRegion && hiddenCity) {

    const updateHiddenFields = () => {
      hiddenRegion.value = regionSelect.value || '';
      hiddenCity.value   = citySelect.value || '';
    };

    jQuery(regionSelect).on('change', updateHiddenFields);
    jQuery(citySelect).on('change', updateHiddenFields);

    updateHiddenFields();
  }
};

export default offlineCourseLocation;
